import { useState } from "react";
import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";

export default function YouTubeInfo() {
  const [url, setUrl] = useState("");
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  const extractVideoId = (youtubeUrl) => {
    const match = youtubeUrl.match(
      /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([a-zA-Z0-9_-]{11})/
    );
    return match ? match[1] : null;
  };

  const handleFetch = async () => {
    const videoId = extractVideoId(url);
    if (!videoId) {
      alert("Enter valid YouTube URL");
      return;
    }

    setLoading(true);
    const videoUrl = `https://www.youtube.com/watch?v=${videoId}`;

    try {
      const response = await fetch(`https://cors-anywhere.herokuapp.com/${videoUrl}`);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");

      const title = doc.querySelector("meta[name='title']")?.content || "N/A";
      const channel = doc.querySelector("link[itemprop='name']")?.getAttribute("content") || "N/A";

      setInfo({
        title,
        channel,
        thumbnail: `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`,
      });
    } catch (err) {
      alert("Something went wrong!");
    }

    setLoading(false);
  };

  return (
    <>
      <Helmet>
        <title>YouTube Video Info Extractor - Free Tool</title>
        <meta
          name="description"
          content="Instantly extract title, channel name, and thumbnail from any YouTube video. Just paste the URL to get video details for free."
        />
        <meta
          name="keywords"
          content="youtube video info extractor, youtube title extractor, youtube thumbnail downloader, extract youtube details, free youtube tool"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://freelity.com/youtube-info-extractor" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2>YouTube Video Info Extractor</h2>

          <input
            type="text"
            className="form-control mb-3"
            placeholder="Paste YouTube Video URL"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
          />

          <button className="btn btn-primary mb-3" onClick={handleFetch} disabled={loading}>
            {loading ? "Fetching..." : "Get Info"}
          </button>

          {info && (
            <div className="text-center">
              <img src={info.thumbnail} alt="Thumbnail" className="img-fluid mb-3" />
              <h5><strong>Title:</strong> {info.title}</h5>
              <h6><strong>Channel:</strong> {info.channel}</h6>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
